import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, __experimentalNumberControl as NumberControl, Dashicon } from '@wordpress/components';

// Settings Components
import Title from '../../Components/Title';
import Background from '../../Components/Background';
import SpaceControl from '../../Components/SpaceControl';

const Settings = ({ attributes, setAttributes }) => {
	const { topPosition, minScreenWidth, maxScreenWidth, background, padding } = attributes;

	return <InspectorControls>
		<Title mt='0' mb='0'></Title>
		<PanelBody className='bPlPanelBody help' title={__('Help', 'sticky-menu')}>
			<div className='helpItem'>
				<a href='https://bblockswp.com/docs/sticky-content-block/' target='_blank' rel='noreferrer'><Dashicon icon='book' />{__('Read Documentation', 'sticky-menu')}</a>
			</div>

			<div className='helpItem rateUs'>
				<a href='https://wordpress.org/support/plugin/sticky-menu-block/reviews/#new-post' target='_blank' rel='noreferrer'>
					<span><Dashicon icon='star-filled' />{__('Would you please rate us?', 'sticky-menu')}</span>
					<span>{__('We are new and we need your help to grow!🙏', 'sticky-menu')}</span>
				</a>
			</div>
		</PanelBody>


		<PanelBody className='bPlPanelBody' title={__('Sticky Settings', 'sticky-menu')}>
			<NumberControl label={__('Top Position (px):', 'sticky-menu')} labelPosition='left' value={topPosition} onChange={val => setAttributes({ topPosition: parseInt(val) })} />

			<NumberControl className='mt20' label={__('Min Screen Width:', 'sticky-menu')} labelPosition='left' value={minScreenWidth} onChange={val => setAttributes({ minScreenWidth: parseInt(val) })} />
			<small>{__('Element will not be sticky when viewport width smaller than "min screen width"', 'sticky-menu')}</small>

			<NumberControl className='mt20' label={__('Max Screen Width:', 'sticky-menu')} labelPosition='left' value={maxScreenWidth} onChange={val => setAttributes({ maxScreenWidth: parseInt(val) })} />
			<small>{__('Element will not be sticky when viewport width larger than "max screen width"', 'sticky-menu')}</small>

			<Background className='mt20' background={background} onChange={val => setAttributes({ background: val })} defaults={{ color: '#333' }} />

			<SpaceControl className='mt20' label={__('Padding:', 'sticky-menu')} space={padding} onChange={val => setAttributes({ padding: val })} defaults={{ vertical: '10px', horizontal: '20px' }} />
		</PanelBody>
	</InspectorControls>;
};
export default Settings;